// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"acc765c1","266":"4aefd0b3","358":"78ed987d","600":"d618e159","821":"510feda5"}[chunkId] + ".chunk.js";
};